module.exports = __webpack_public_path__ + "img/646bd82.png";